import { render, staticRenderFns } from "./H5_order_report.vue?vue&type=template&id=56d94284&scoped=true&"
import script from "./H5_order_report.vue?vue&type=script&lang=js&"
export * from "./H5_order_report.vue?vue&type=script&lang=js&"
import style0 from "./H5_order_report.vue?vue&type=style&index=0&id=56d94284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d94284",
  null
  
)

export default component.exports